import { getRequest, getRequestWithParams, postRequest  } from './requests';

class NotificacoesService {  
  getBell = () =>
    new Promise((resolve, reject) => {
      getRequest(`/notificacoes/bell`, resolve, reject);
    });

  get = (data) =>
    new Promise((resolve, reject) => {
      getRequestWithParams(`/notificacoes`,data, resolve, reject);
    });
    
  post = (data) =>
  new Promise((resolve, reject) => {
    postRequest(`/notificacoes`,data, resolve, reject);
  });
    
}

export default new NotificacoesService();
